/* eslint-disable @typescript-eslint/no-explicit-any */
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.tsx';
import { FJMediaImportListStatus, FJMediaImportModelType } from '../../../../constants/FJMediaImportConstant.js';
import FJMediaImportFolder from './FJMediaImportFolder.tsx';
import FJMediaImportFile from './FJMediaImportFile.tsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import { Fragment, useState } from 'react';
import FJDropSwitch from '../../../../common/components/FJDropSwitch/FJDropSwitch.tsx';
import FJNoResults from '../../../../common/components/FJNoResult/FJNoResults';
import classNames from 'classnames';
import FJRetryIcon from '../../../../assets/retry.svg?react';
import FJLoading from '../../../../common/components/FJLoading/FJLoading';
import styles from './FJMediaImportContent.module.less';

interface MediaImportItem {
    id: string;
    modelType: string;
    duration?: number;
    [key: string]: any; // 允许其他未知属性
}

interface Props {
    models: MediaImportItem[];
    status: string;
    loadingMetaData?: any[] | undefined;
    onTotalScroll?: () => void;
    onClickFolder?: (item: any) => void;
    onClickFile?: (e: any) => void;
    onDoubleClickFile?: (e: any) => void;
    onRetry?: () => void;
    className: string;
    folderClassName: string;
    fileClassName: string;
    folderListClassName: string;
    folderSwitchClassName: string;
    fileSwitchClassName: string;
    fileWrapperClassName: string;
    fileListClassName: string;
    selectedFileIds: string[];
    supportSelect: boolean;
    showDuration: boolean;
}

const FJMediaImportContent = ({
    models,
    status,
    onTotalScroll,
    onClickFolder,
    onClickFile,
    onDoubleClickFile,
    onRetry,
    className,
    folderClassName,
    fileClassName,
    folderListClassName,
    folderSwitchClassName,
    fileSwitchClassName,
    fileWrapperClassName,
    fileListClassName,
    selectedFileIds,
    supportSelect,
    showDuration,
}: Props) => {
    const hasModels = models.length > 0;
    const [isFoldExpand, setIsFoldExpand] = useState(true);
    const [isFileExpand, setIsFileExpand] = useState(true);

    const FolderList = () => {
        const hasFolder = models.some(model => model.modelType === FJMediaImportModelType.folder);
        return (
            <>
                {hasFolder ? (
                    <FJDropSwitch
                        className={folderSwitchClassName}
                        isExpand={isFoldExpand}
                        text='folders'
                        onClick={setIsFoldExpand}
                        style={{ display: 'flex' }}
                    />
                ) : null}
                {isFoldExpand ? (
                    <div className={classNames(styles.list, folderListClassName)}>
                        {models.map((model, index) => {
                            return model.modelType === FJMediaImportModelType.folder ? (
                                <Fragment key={`${model.id}-${index}`}>
                                    <FJMediaImportFolder
                                        itemModel={model}
                                        onClick={onClickFolder ? onClickFolder : () => null}
                                        className={folderClassName}
                                    />
                                </Fragment>
                            ) : null;
                        })}
                    </div>
                ) : null}
            </>
        );
    };

    const FileList = () => {
        const hasFile = models.some(model => model.modelType !== FJMediaImportModelType.folder);
        return (
            <>
                {hasFile ? (
                    <FJDropSwitch
                        className={fileSwitchClassName}
                        isExpand={isFileExpand}
                        text='files'
                        onClick={setIsFileExpand}
                        style={{ display: 'flex' }}
                    />
                ) : null}
                {isFileExpand ? (
                    <div className={classNames(styles.list, fileListClassName)}>
                        {models.map((model, index) => {
                            return model.modelType !== FJMediaImportModelType.folder ? (
                                <FJMediaImportFile
                                    showDuration={showDuration}
                                    duration={model.duration}
                                    key={`${model.id}-${index}`}
                                    selected={selectedFileIds?.includes(model.id)}
                                    supportSelect={supportSelect}
                                    wrapperClassName={fileWrapperClassName}
                                    itemModel={model}
                                    onClick={onClickFile}
                                    onDoubleClick={onDoubleClickFile}
                                    className={fileClassName}
                                />
                            ) : null;
                        })}
                    </div>
                ) : null}
            </>
        );
    };

    return (
        <div className={classNames(styles.container, className)}>
            <FJVerticalScroller className={styles.scroller} onTotalScroll={onTotalScroll}>
                {hasModels ? (
                    <>
                        {FolderList()}
                        {FileList()}
                    </>
                ) : null}

                {status === FJMediaImportListStatus.success && !hasModels ? (
                    <FJNoResults
                        text={FJLocalStore._('no-resources-available')}
                        style={{ height: '100%', width: '100%' }}
                        isSearchEmpty={false}
                    />
                ) : null}

                {status === FJMediaImportListStatus.loading ? (
                    <div className={styles.loading} style={{ height: '100%' }}>
                        <FJLoading strokeColor={'#9FA2AF'} style={{ width: 25, height: 25 }} />
                    </div>
                ) : null}

                {status === FJMediaImportListStatus.failed && !hasModels ? (
                    <div className={styles.error}>
                        <FJNoResults text={FJLocalStore._('failed-to-load-resources')} />
                        <div className={styles.button} onClick={onRetry}>
                            <FJRetryIcon className={styles.icon} />
                            <div>{FJLocalStore._('try-again')}</div>
                        </div>
                    </div>
                ) : null}
            </FJVerticalScroller>
        </div>
    );
};

export default FJMediaImportContent;
